<template>
  <div class="flex flex-wrap items-start gap-3">
    <UtilityBadge v-for="badge in badges" :key="badge">{{ badge }}</UtilityBadge>
  </div>
</template>
<script setup lang="ts">
defineProps({
  badges: {
    type: Array,
    required: true,
  },
})
</script>
